// Score d'une partie (#37) : le temps de jeu d'abord, chaque nouveau kami photographié un peu. Une partie va de « Jouer » (ou de
// « Continuer » après une charge, ou de « Rejouer ») jusqu'à la batterie vide ou la fin du dernier niveau : passer un niveau la
// prolonge, avec une batterie pleine. La rareté des kamis (#33, point 4) n'est pas encore décidée : elle n'entre pas dans le score.
// Fonctions pures.
import { SCORE_POINTS_PER_SECOND, SCORE_POINTS_PER_KAMI } from '../config/constants.js';

/**
 * Points d'une partie : SCORE_POINTS_PER_SECOND par seconde de jeu entière, SCORE_POINTS_PER_KAMI par nouveau kami photographié.
 * @param {{ seconds: number, kamis: number }} run  secondes de jeu (comptées comme l'autonomie de la batterie) et nouveaux kamis
 */
export function scoreOf({ seconds, kamis }) {
  const wholeSeconds = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
  const newKamis = Number.isFinite(kamis) && kamis > 0 ? Math.floor(kamis) : 0;
  return wholeSeconds * SCORE_POINTS_PER_SECOND + newKamis * SCORE_POINTS_PER_KAMI;
}

/** Un nombre de points : entier positif, sinon 0. */
function toPoints(raw) {
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
}

/** Meilleur score lu depuis le stockage : un entier positif, sinon 0. */
export function sanitizeBestScore(raw) {
  return toPoints(raw);
}

/**
 * Fin de partie : le meilleur score une fois celle-ci comptée, et si elle l'a battu. `before` est le meilleur score au début de la
 * partie (il a pu être enregistré en cours de route, voir game.js#saveBestScore).
 */
export function settleBest(before, score) {
  return { best: Math.max(before, score), isNewBest: score > before };
}

/** Score lisible, groupé par milliers selon la langue : « 12 345 » en français, « 12,345 » en anglais. */
export function formatScore(score, language) {
  return new Intl.NumberFormat(language === 'fr' ? 'fr-FR' : 'en-US').format(toPoints(score));
}
